import styled from 'react-emotion';
import BaseButton from '../BaseButton/BaseButton';

export const RectangleButtonWrapper = styled(BaseButton)`
  width: ${props => (props.horizontal ? '100%' : 'auto')};
  height: ${props => (props.horizontal ? '100%' : 'auto')};
  min-width: auto;
  min-height: auto;
`;
